import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.timers.js";
import IxDialog from '~/components/ix/Dialog.vue';
import IxButtonAction from '~/components/ix/button/Action.vue';
import { waitForEsgSaves } from '~/functions/esgSavePending';
export default defineComponent({
  components: {
    IxDialog: IxDialog,
    IxButtonAction: IxButtonAction
  },
  props: {
    nextStep: {
      type: Object
    },
    previousStep: {
      type: Object
    },
    isOutro: {
      type: Boolean
    },
    isCompleted: {
      type: Boolean,
      required: false,
      default: undefined
    }
  },
  data: function data() {
    return {
      showIncompleteDialog: false,
      isWaitingForSave: false
    };
  },
  methods: {
    handleNextStep: function handleNextStep(nextStep) {
      this.$emit('change', nextStep);
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },
    onContinue: function onContinue() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!_this.nextStep || _this.isWaitingForSave)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              if (!_this.isCompleted) {
                _context.next = 5;
                break;
              }
              _this.handleNextStep(_this.nextStep);
              return _context.abrupt("return");
            case 5:
              // Pending measure updates can leave sectionCompletion stale for a beat.
              // Wait for saves; if the section becomes complete, continue without warning.
              _this.isWaitingForSave = true;
              _context.prev = 6;
              _context.next = 9;
              return waitForEsgSaves();
            case 9:
              _context.next = 11;
              return _this.$nextTick();
            case 11:
              _context.next = 13;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 150);
              });
            case 13:
              _context.prev = 13;
              _this.isWaitingForSave = false;
              return _context.finish(13);
            case 16:
              if (!_this.isCompleted) {
                _context.next = 19;
                break;
              }
              _this.handleNextStep(_this.nextStep);
              return _context.abrupt("return");
            case 19:
              _this.showIncompleteDialog = true;
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[6,, 13, 16]]);
      }))();
    }
  }
});